export const initialUser = {
  name: "",
  email: "",
  password: "",
  cpassword: "",
};
